// @flow
import * as React from 'react';
import { pure } from 'recompose';
import { Alert, ListGroup, ListGroupItem, Row } from 'angieslist-react-components';
import { stylesColors } from 'angieslist-styles';
import { urlCatalog } from 'angieslist-app-platform';
import { map, isEmpty } from 'lodash';
import Loader from 'angieslist-app-platform/lib/browser/Loader';

type City = {
  id: string,
  displayText: string,
}

type Props = {
  isLoading: boolean,
  error: string,
  showDefault: boolean,
  cities: Array<City>,
  onCitySelect: (cityId: string, cityName: string) => void,
};

const CitySearchResultsComponent = ({
  isLoading, error, showDefault, cities, onCitySelect,
}: Props): React.Node => (
  <div style={{ height: '95%', marginTop: '1em' }}>
    <Loader
      loading={isLoading}
      element={
        <Row className="category-row text-center" style={{ marginTop: '1em' }}>
          <i className="icon icon-load icon-spin icon-3x text-primary" />
        </Row>}
    >
      <Choose>
        <When condition={error}>
          <Alert bsStyle="danger">There was a problem retrieving this city.  Please contact us at&nbsp;
            <a
              id="service-areas--add-service-area--store-error-link"
              href={urlCatalog.global.businessCenterPhone()}
              style={{ whiteSpace: 'nowrap' }}
            >{urlCatalog.global.businessCenterPhoneText()}
            </a> for assistance.
          </Alert>
        </When>
        <When condition={showDefault}>
          <Row style={{ margin: '2em 2em 0', textAlign: 'center' }}>
            <span className="icon-stack icon-2x">
              <i className="icon icon-circle icon-stack-2x" style={{ color: stylesColors.backgroundGray }} />
              <i className="icon icon-location icon-stack-1x" />
            </span>
            <p>
              <strong>Search by City Name to View a List of ZIP Codes.</strong>
            </p>
            <hr />
          </Row>
          <Row className="small">
            <p>To view service areas as a list, search by city name. ZIP Codes in that city will
                be displayed.
            </p>
            <p>You can turn on and off ZIP Codes to add or remove them from your service area.
                Changes that you make will appear on the map.
            </p>
          </Row>
        </When>
        <When condition={isEmpty(cities)}>
            No results found
        </When>
        <Otherwise>
          <ListGroup id="service-area--city-search-results--list-group">
            {
            map(cities.map(city => (
              <ListGroupItem
                key={city.id}
                id={`city-selection--search-results--city-${city.id}`}
                style={{
                  border: 'none',
                  borderBottom: `1px solid ${stylesColors.lightGray}`,
                  width: '100%',
                  paddingTop: '1em',
                  paddingBottom: '.5em',
                  marginBottom: 1,
                  textAlign: 'left',
                }}
                onClick={() => onCitySelect(city.id, city.displayText)}
              >
                <i className="pull-right icon icon-right-open-big" />
                <p style={{
                  width: '80%',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
                >{city.displayText}
                </p>

              </ListGroupItem>
            )))
          }
          </ListGroup>
        </Otherwise>
      </Choose>
    </Loader>
  </div>
);

export default (pure(CitySearchResultsComponent): any);



// WEBPACK FOOTER //
// ./src/app/browser/service-areas/CitySearchResults.js